export function availableCreditBalance(credits, today = new Date().toISOString().slice(0, 10)) {
    const amount = value => Number.isFinite(Number(value)) ? Math.max(0, Number(value)) : 0;
    const expiration = credits?.promotional_credit_expiration_date;
    const promotionalIsActive = !expiration || (/^\d{4}-\d{2}-\d{2}$/.test(expiration) && expiration >= today);
    return amount(credits?.credits) + (promotionalIsActive ? amount(credits?.promotional_credits) : 0) + amount(credits?.purchased_credits);
}
